
  import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
  import ParkEventCell from "@/modules/ParksConfig/components/ParkEvents/ParkEventCell.vue";
  import {IParkEvent} from "@/modules/ParksConfig/interfaces/park-event.interface";
  import type {IParksConfig} from "@/modules/ParksConfig/interfaces/parks-config.interface";
  import CarsUnionCell from "@/modules/CarList/components/carsUnion/CarsUnionCell.vue";
  import {bus} from "@/plugins/bus";

  @Component({
    components: {
      CarsUnionCell,
      ParkEventCell,
    }
  })
  export default class ParkEventRow extends Vue {
    @Prop() park: IParksConfig.IPark;
    @Prop() parkEvent: IParkEvent.IEntity;
    @Prop() index: number;
    @Prop() cells: IParkEvent.ITableCell[];
    @Prop() active: boolean;

    $refs: any;
    publicPath = process.env.VUE_APP_PUBLIC_URL;
    propType = IParkEvent.PropType;
    defaultForm = {
      id: null,
      dateBeg: '',
      dateEnd: '',
      tSum: null,
      tSumAll: null,
      dateUpd: '',
      persName: '',
      parkName: '',
      comment: '',
      enabled: true,
    };
    formModel: any = {};
    startModel: any = {};
    clickedCell = null;
    errorProps = [];
    hasChanges = false;
    dontClearData = false;

    prepareData() {
      this.formModel = {...this.defaultForm};
      this.startModel = {...this.defaultForm};

      let values = {
        // dateBeg: this.formModel.dateBeg ? moment(this.formModel.dateBeg).format(IApp.DateFormats.PrintedDateTime) : '',
        // dateEnd: this.formModel.dateEnd ? moment(this.formModel.dateEnd).format(IApp.DateFormats.PrintedDateTime) : '',
        // parks: this.parkEvent.parks ? this.parkEvent.parks : [],
      };
      Object.keys(this.defaultForm).forEach(prop => {
        let formNames = ['formModel', 'startModel'];
        formNames.forEach(formName => {
          if (values[prop])
            Vue.set(this[formName], prop, values[prop]);
          else
            Vue.set(this[formName], prop, this.parkEvent[prop]);
        });
      });
    }

    async removeRow(index) {
      let formToSend = {
        ...this.parkEvent,
        enabled: !this.parkEvent.enabled,
      };
      let success = await this.$store.dispatch('parksConfig/saveParkEvent', {
        formModel: formToSend,
        index: index,
        parkId: this.park.id,
        changeEnabled: true,
      });

      if (success) {
        this.hasChanges = true;
        this.$notify({
          title: 'Успешно',
          message: `Данные успешно ${this.parkEvent.enabled ? 'удалены' : 'восстановлены' }`,
          type: 'success'
        });
      }
    }

    async saveData(remove: boolean = false) {
      let success = true;
      this.validateForm();

      if (this.hasChanges && !this.errorProps.length) {
        let formToSend = {
          ...this.formModel,
          enabled: !remove,
        };
        success = await this.$store.dispatch('parksConfig/saveParkEvent', {
          formModel: formToSend,
          index: this.index,
          parkId: this.park.id,
        });

        if (success) {
          this.hasChanges = true;
          this.$notify({
            title: 'Успешно',
            message: 'Данные успешно сохранены',
            type: 'success'
          });
        }
      }

      return success;
    }

    validateForm() {
      this.hasChanges = false;
      Object.keys(this.formModel).forEach(prop => {
        let indexProp = this.errorProps.findIndex(item => item === prop);

        switch (prop) {
          // case 'parks':
          //   if(!_.isEqual(this.formModel.parks, this.startModel.parks)) this.hasChanges = true;
          //   break;

          default:
            if (this.formModel[prop] !== this.startModel[prop]) this.hasChanges = true;
            break;
        }
      });
    }

    activateRow() {
      this.$emit('activateRow', this.index);
    }

    clickOnCell(cell: IParkEvent.ITableCell) {
      this.clickedCell = cell;
    }

    revertChanges() {
      this.clearData(true);
      this.$emit('activateRow', null);
    }

    async applyChanges() {
      this.validateForm();
      if (!this.errorProps.length) {
        this.$emit('activateRow', null);
      }
    }

    clearData(revert = false) {
      if (revert) {
        this.formModel = {...this.startModel};
      }
      else {
        this.formModel = {...this.defaultForm};
        this.startModel = {...this.defaultForm};
      }
      this.clickedCell = null;
      this.errorProps = [];
      this.hasChanges = false;
    }

    openEventsLog() {
      this.$store.dispatch('dialog/openDialog', {
        blockName: 'parksConfig',
        dialogName: 'parkEventsLog',
        payload: {
          id: this.parkEvent.id
        }
      });
    }

    @Watch('active')
    async onActiveChange() {
      if (this.active && !this.errorProps.length) {
        if (!this.dontClearData) {
          this.prepareData();
        }
      }
      else {
        let success = await this.saveData();

        if (success) {
          this.dontClearData = false;
          if (!this.hasChanges && !this.formModel.id) {
            this.revertChanges();
            this.$store.commit('parksConfig/clearNewParkEvent');
          }
          else {
            if (this.errorProps.length) {
              this.activateRow();
            }
            else {
              this.clearData();
            }
          }
        }
        else {
          this.dontClearData = true;
          this.activateRow();
        }
      }
    }
  }
